/**
 * retryPolicy — the field queue's retry cap, on its own.
 *
 * drainFieldQueue spends it (an item's third HTTP failure marks it 'failed')
 * and FieldSyncSheet renders it ("retry n/3"). It lives here, not in
 * drainFieldQueue, so a component can read it without importing the drain:
 * the drain imports preflightToken, which imports msalInstance, which builds
 * an MSAL client at module load (and throws in jsdom). This module has no
 * imports, by design; keep it that way.
 */
export const MAX_RETRIES = 3;
